export var TrackingEventsEnum;
(function (TrackingEventsEnum) {
    TrackingEventsEnum["LINK"] = "link";
    TrackingEventsEnum["VIEW"] = "view";
})(TrackingEventsEnum || (TrackingEventsEnum = {}));
//# sourceMappingURL=tracking-events.enum.js.map